import { render, staticRenderFns } from "./BDProductOrderModal.vue?vue&type=template&id=03093460&scoped=true&"
import script from "./BDProductOrderModal.vue?vue&type=script&lang=js&"
export * from "./BDProductOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./BDProductOrderModal.vue?vue&type=style&index=0&id=03093460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03093460",
  null
  
)

export default component.exports